import Focus from '../../../shared/types/enums/focus';
import Rail from '../../../shared/classes/rail';
import TMain from '../templates/main';
import watchEverythingObservable from '../../../shared/api/watchEverything/observable';
import { Observer, Subscription } from 'rxjs';
import { routerSelector } from '../../../shared/store/slices/router.slice';
import { setFocus } from '../../../shared/store/slices/focus.slice';
import { useAppDispatch, useAppSelector } from '../../../shared/store/hooks';
import { useState, useEffect } from 'react';

function WatchEverything() {
  const dispatch = useAppDispatch();
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);

  const [complete, setComplete] = useState(false);
  const [rails, setRails] = useState<Rail[]>([]);

  useEffect(() => {
    let subscription: Subscription | null = null;
    if (currentParams?.channelName && !complete) {
      const observer: Observer<Rail[]> = {
        next: (val) => {
          setRails(val);
        },
        error: () => {
          console.error('Error recovering content');
        },
        complete: () => {
          setComplete(true);
          setComplete(true);
          dispatch(
            setFocus([
              Focus.RAILS_LIST,
              parseInt(`${Focus.RAILS_SUB_LIST}${0}`),
            ])
          );
          return null;
        },
      };
      subscription = watchEverythingObservable(
        (currentParams as { channelName: string })?.channelName
      ).subscribe(observer as Partial<Observer<unknown>>);
    }

    return () => {
      subscription?.unsubscribe();
    };
  }, [currentParams, complete]);

  return (
    <TMain
      complete={complete}
      rails={rails}
      sliders={[]}
      startsInMenu={false}
    />
  );
}

export default WatchEverything;
